<template>
    <div class="row mx-auto my-2 py-4">
        <div class="col-md-3 p-0 mx-auto">
            <qr-maker></qr-maker>
        </div>
        <div class="col-md mx-auto p-3">
            <div class="row mx-auto">
                <v-expansion-panels class="px-1">
                    <v-expansion-panel class="mb-1">
                        <v-expansion-panel-header class="text-right">
                            توییتر
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div class="col-md-12 mx-auto">
                                <v-radio-group class="mt-0 pt-0 px-0 mx-0" row v-model="data.kind">
                                    <v-radio
                                            value="profile"
                                            label="پروفایل"
                                    >
                                    </v-radio>
                                    <v-radio
                                            label="توییت"
                                            value="tweet"
                                            class="my-2"
                                    ></v-radio>
                                </v-radio-group>
                            </div>
                            <div v-if="data.kind==='profile'" class="col-md-8">
                                <v-text-field outlined
                                              dense
                                              v-model="data.profile"
                                              hint="لطفا نام کاربری خود را وارد کنید."
                                              maxLength="50"
                                              counter="50"
                                              label="نام کاربری"
                                              append-icon="mdi-human"/>
                            </div>
                            <div v-if="data.kind === 'tweet'" class="col-md-12 mx-auto">
                                <v-textarea outlined
                                            dense
                                            rows="4"
                                            v-model="data.message"
                                            hint="لطفا متن پست موردنظر خود را وارد کنید."
                                            maxLength="100"
                                            counter="100"
                                            label="متن "
                                            append-icon="mdi-pencil"/>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
            <qr-generator></qr-generator>
        </div>
    </div>
</template>

<script>
import QrGenerator from "./qrGenerator";
import QrMaker from "./qrMaker";
export default {
    name: "qrTwitter",
    components: {QrMaker, QrGenerator},
    data(){
        return{
            data:{
                kind:'profile',
                profile:'',
                message:'',

            }
        }
    }
}
</script>

<style scoped>

</style>